import zydusLogo from "../assets/clients/zydus.png";
import unisonLogo from "../assets/clients/unison.png";
import britishBioLogo from "../assets/clients/british-bio.png";
import cadilaLogo from "../assets/clients/cadila.png";
import keplerLogo from "../assets/clients/kepler.png";
import emamiLogo from "../assets/clients/emami.png";
import acmedixLogo from "../assets/clients/acmedix.png";
import AntiCounterfeiting from "../assets/clients/AntiCounterfeiting1.png";
import ProductDevelopment from "../assets/clients/ProductDevelopment.png";
import MedicalWriting from "../assets/clients/MedicalWriting.png";



export const websiteContent = {
    // Company Info
    company: {
        name: "SCINOVA SCIENTIFICS",
        tagline: "SCIENCE AS A SERVICE",
        description: "Scinova Scientifics is a young, strong and dynamic team of highly experienced professional consultants who are passionate on delivering Science as a Service for Healthcare, Pharmaceutical and allied Organizations."
    },

    // Hero Section
    hero: {
        mainHeading: "We are Scinova Scientifics",
        subtitle: "SCIENCE AS A SERVICE",
        description: "We strive to deliver a super blend of Science, Technology, innovation and strategy as part of the solution, which is our unique offering.",
        backgroundImage: "https://images.unsplash.com/photo-1609188076864-c35269136b09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxwaGFybWFjZXV0aWNhbCUyMHJlc2VhcmNofGVufDB8fHx8MTc2ODM2NDU2M3ww&ixlib=rb-4.1.0&q=85"
    },

    // Services Section
    services: {
        title: "SERVICES OFFERED BUT NOT LIMITED TO",
        categories: [
            {
                id: 1,
                title: "High-end Tech Support",
                items: [
                    "Nutrigenomics profiling",
                    "Anti-counterfeit tech",
                    "New Product sourcing",
                    "Product Development"
                ]
            },
            {
                id: 2,
                title: "Scientific Content Generation (Multilingual)",
                items: [
                    "Product Monographs",
                    "Campaign Management - Call support"
                ]
            },
            {
                id: 3,
                title: "CME Content",
                items: [
                    "Print CMEs",
                    "2 minutes connect",
                    "PG connects"
                ]
            }
        ]
    },

    // Detailed Service Descriptions
    serviceDetails: [
        {
            id: 1,
            title: "Nutrigenomics Profiling",
            icon: "🧬",
            image: "https://images.unsplash.com/photo-1641903202531-bfa6bf0c6419?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxETkElMjBnZW5ldGljc3xlbnwwfHx8fDE3NjgzNjQ1Nzh8MA&ixlib=rb-4.1.0&q=85",
            description: "We have partnered with high tech Gene Labs to get the cutting-edge technologies to offer Nutrigenomics services to our clients. This field is striding rapidly and will be a popular destination in future for healthcare decision making.",
            features: [
                "Personalized DNA Analysis for Nutrition Planning",
                "Genetic Testing for Dietary Requirements",
                "Customized Health & Wellness Programs",
                "Gene-Diet Interaction Studies",
                "Preventive Healthcare through Genomics"
            ],
            detailedInfo: "Nutrigenomics is the scientific study of the interaction between nutrition and genes. Our advanced profiling services help individuals understand how their genetic makeup influences their response to different nutrients, enabling personalized nutrition plans that optimize health outcomes. We work with certified laboratories to provide comprehensive genetic analysis and actionable insights."
        },
        {
            id: 2,
            title: "Anti-counterfeit Technology",
            icon: "🔒",
            // link: "https://qrmor.in",
            image: AntiCounterfeiting,
            description: "We also know the importance of delivering secure products to your esteemed customers, while protecting them from counterfeit products. In a way, we help you protect your valuable assets in the market place and pave a way for them to stand reputed.",
            features: [
                "QR Code Based Product Authentication",
                "Track & Trace Solutions",
                "Secure Packaging Technologies",
                "Real-time Product Verification",
                "Brand Protection Services"
            ],
            detailedInfo: "In today's market, counterfeiting poses a serious threat to pharmaceutical and healthcare companies. Our anti-counterfeit technology solutions use advanced QR codes and digital authentication methods to ensure product integrity from manufacturing to end consumer. Each product can be uniquely identified and tracked throughout the supply chain, providing complete transparency and security."
        },
        {
            id: 3,
            title: "Product Development & Sourcing",
            icon: "🌍",
            image: ProductDevelopment,
            description: "Innovation is the way to go. We offer innovative services on crucial product development, world-wide product sourcing and technologies to keep you ahead of the race.",
            features: [
                "New Product Development Consulting",
                "Global Ingredient Sourcing",
                "Formulation Optimization",
                "Market Research & Analysis",
                "Regulatory Compliance Support"
            ],
            detailedInfo: "Our product development team brings decades of combined experience in pharmaceutical and nutraceutical product innovation. We assist clients from concept to commercialization, providing end-to-end support including formulation development, sourcing of high-quality ingredients from trusted global suppliers, and ensuring compliance with international standards."
        },
        {
            id: 4,
            title: "Medical Writing & Content",
            icon: "📝",
            image: MedicalWriting,
            description: "We specialize in medical writing and scientific content development. The experienced writers and reviewers, primarily consisting of M.Pharm, MD Pharma and PhDs, deliver high-quality, balanced scientific documents ensuring consistency and adherence to style and format.",
            features: [
                "Multilingual Medical Content",
                "Product Monographs & Literature",
                "CME Content Development",
                "Regulatory Documentation",
                "AI-Assisted Content Creation"
            ],
            detailedInfo: "Our team of qualified medical writers (M.Pharm, MD, PhD) creates scientifically accurate and engaging content for pharmaceutical companies, healthcare providers, and research organizations. We have evolved the art of using AI in a controlled way to deliver impeccable content while maintaining the highest standards of scientific integrity and accuracy."
        }
    ],

    // About Section
    about: {
        title: "Why Choose Us?",
        description: "A well-written content is essential for accurate information dissemination, regulatory compliance, and patient care. Whether you're a pharmaceutical company, a research organization, or a healthcare provider, we offer high standards of communication and documentation.",
        values: [
            {
                title: "Excellence",
                description: "Committed to delivering the highest quality services",
                icon: "⭐"
            },
            {
                title: "Innovation",
                description: "Embracing cutting-edge technologies and methodologies",
                icon: "💡"
            },
            {
                title: "Integrity",
                description: "Maintaining scientific accuracy and ethical standards",
                icon: "🛡️"
            },
            {
                title: "Partnership",
                description: "Building long-term relationships with our clients",
                icon: "🤝"
            }
        ]
    },

    // Clients Section
    clients: {
        title: "Our Esteemed Clients",
        subtitle: "We value your business and would like to associate with you as a service provider.",
        note: "*Gurukrupa Enterprise & Scinova Scientifics",
        companies: [
            {
                name: "Zydus",
                logo: zydusLogo
            },
            {
                name: "UNISON",
                logo: unisonLogo
            },
            {
                name: "British Bio",
                logo: britishBioLogo
            },
            {
                name: "Cadila",
                logo: cadilaLogo
            },
            {
                name: "Kepler",
                logo: keplerLogo
            },
            {
                name: "Emami",
                logo: emamiLogo
            },
            {
                name: "Acmedix",
                logo: acmedixLogo
            }
        ]

    },

    // Contact Section
    contact: {
        title: "Contact Us",
        subtitle: "Let's Build Something Meaningful",
        description: "Whether you're in Pharma, Healthcare, Wellness, or Research – we're ready to partner with you.",
        address: {
            company: "Scinova Scientifics",
            unit: "A unit of Gurukrupa Enterprise",
            street: "609, Athens, Opp. Zanshi Rani Statue",
            area: "Shiv Ranjani Cross Roads, Satellite",
            city: "Ahmedabad, India – 380015"
        },
        phones: [
            "+91 99740 51262",
            "+91 98250 97907"
        ],
        emails: [
            "padmarajg@scinovas.com",
            "chaitanya@scinovas.com"
        ]
    },

    // Footer
    footer: {
        copyright: `© ${new Date().getFullYear()} Scinova Scientifics – All Rights Reserved.`,
        tagline: "Delivering Science as a Service"
    },

    // Navigation Menu
    navigation: {
        items: [
            { id: "home", label: "Home" },
            { id: "services", label: "Services" },
            { id: "about", label: "About Us" },
            { id: "clients", label: "Clients" },
            { id: "contact", label: "Contact Us" }
        ]
    }
};
